import { useState, useEffect } from "react";
import { cloneDeep } from "lodash";

/**
 * @desc Custom hook for display products.
 */
export const useDisplayProducts = ({ products, wishlist = [] }) => {
  // HOOK STATE ---------------------------------------------------------------

  const [displayProducts, setDisplayProducts] = useState(products || []);

  // SIDE EFFECTS -------------------------------------------------------------

  /**
   * @desc Whenever products or wishlist changes, update displayed products.
   */
  useEffect(() => {
    let result = cloneDeep(products);
    if (
      wishlist.show &&
      Array.isArray(wishlist.pskus) &&
      Array.isArray(products)
    ) {
      result = products.filter(({ sku }) => wishlist.pskus.includes(sku));
    }
    setDisplayProducts(result);
  }, [wishlist.show, products, wishlist.pskus]);

  // HOOK ---------------------------------------------------------------------

  return displayProducts;
};
